import React, { PropsWithChildren } from 'react';
import PublicNavigation from './PublicNavigation';

const withPublicNavigation = <P,>(
  Component: React.ComponentType<P>,
): React.FC<PropsWithChildren<P>> => {
  const WrappedComponent: React.FC<PropsWithChildren<P>> = (props: PropsWithChildren<P>) => (
    <PublicNavigation>
      <Component {...props} />
    </PublicNavigation>
  );

  return WrappedComponent;
};

export default withPublicNavigation;
